import {
  PageLoader,
  useParams,
  DataGridColumnConfigProvider,
  workboardFlowQuery,
} from '@diana/core';
import { useQuery } from '@tanstack/react-query';
import { WorkboardContainer } from './WorkboardContainer';

export function WorkboardPage() {
  const { flowId } = useParams<{ flowId: string }>();
  const workboardFlowGet = workboardFlowQuery.getById({ flowId: flowId ?? '' });

  const { isLoading: isFlowLoading, data: flow } = useQuery({
    queryKey: workboardFlowGet.key,
    queryFn: workboardFlowGet.fn,
    staleTime: Infinity,
    enabled: Boolean(flowId),
  });

  const dataGridStorageKey = `workTable.worktable-${flow?.flowOriginId ?? ''}`;

  if (isFlowLoading || !flow) return <PageLoader isLoading />;

  return (
    <DataGridColumnConfigProvider
      flow={flow}
      updateKey={workboardFlowGet.key}
      storageKey={dataGridStorageKey}
    >
      <WorkboardContainer flow={flow} dataGridStorageKey={dataGridStorageKey} />
    </DataGridColumnConfigProvider>
  );
}
